import {
  defaultBuldingTypeDetails,
  mapBuildingDetails,
  mapFreestanding,
} from 'scenes/common/api/quote/marshaller/assets';
import { WireBuilding } from 'scenes/common/api/quote/types';
import { BuildingType } from 'scenes/common/types';
import { LandlordFunnelState } from 'scenes/landlord/flows/types';
import {
  getBuildingType,
  getNumberOfBedrooms,
  getPropertyBuiltYear,
  getRoofMaterial,
  getUnitLevel,
  getWallMaterial,
  hasCertificateOfOccupancy,
  isFreestandingAboveGround,
  isFreestandingMultiStorey,
  isTerraceMultiStorey,
  isTerraceUnderStrata,
  isTownhouseMultiStorey,
  isTownhouseUnderStrata,
  isUnitMultiStorey,
  isUnitUnderStrata,
  isUnitWithContentsOnlyCover,
} from 'scenes/landlord/selectors';

export const mapBuildingTypeDetails = (state: LandlordFunnelState) => {
  switch (getBuildingType(state)) {
    case BuildingType.FreestandingHouse:
      return mapFreestanding(
        isFreestandingAboveGround(state),
        isFreestandingMultiStorey(state)
      );
    case BuildingType.Terrace:
      return mapBuildingDetails(
        isTerraceMultiStorey(state),
        isTerraceUnderStrata(state)
      );
    case BuildingType.Townhouse:
      return mapBuildingDetails(
        isTownhouseMultiStorey(state),
        isTownhouseUnderStrata(state)
      );
    case BuildingType.Unit:
      return mapBuildingDetails(
        isUnitMultiStorey(state),
        isUnitUnderStrata(state),
        getUnitLevel(state)
      );
    default:
      return defaultBuldingTypeDetails;
  }
};

export const toWireBuilding = (state: LandlordFunnelState): WireBuilding => ({
  ...mapBuildingTypeDetails(state),
  numberOfRooms: getNumberOfBedrooms(state),
  type: getBuildingType(state),
  roof: isUnitWithContentsOnlyCover(state) ? undefined : getRoofMaterial(state),
  wall: isUnitWithContentsOnlyCover(state) ? undefined : getWallMaterial(state),
  year: isUnitWithContentsOnlyCover(state)
    ? undefined
    : getPropertyBuiltYear(state),
  hasCOO: hasCertificateOfOccupancy(state),
});
